import Service from "../DepartmentService";

function GetByDepartmentId() {
    return Service.get('Term/ByDepartment');
}

const TermService = {
    GetByDepartmentId
};

export default TermService;
